var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{attrs:{"value":_vm.activeTab,"rounded":"","dense":"","mandatory":"","color":"primary"},on:{"change":_vm.onChange}},_vm._l((_vm.availableTabs),function(tab){return _c('v-btn',{key:tab.id,attrs:{"value":tab.value}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }